/**
 * The exact booked price, shown to a paying carrier who quoted and lost when
 * the shipper company discloses it.
 *
 * Whether it is disclosed is decided server-side — the shipper company's switch
 * plus a minimum number of distinct quoting carriers — so this component only
 * renders what the endpoint hands it. See
 * docs/engineering/design/shipper_company_price_reveal_control_design.md.
 */
import { Typography } from "@mui/material";

import { formatPrice } from "utils";

interface BookedPriceDisplayProps {
  price: number;
  currencyCode: string;
}

export function BookedPriceDisplay(props: BookedPriceDisplayProps) {
  const { price, currencyCode } = props;

  return (
    <Typography variant="body2" sx={{ mb: 1 }}>
      {`Booked price: $${formatPrice(price.toString(), currencyCode)}`}
    </Typography>
  );
}
